export const buildSuccessfulPaymentSavePayload = ({
  order,
  response,
  registrationDbId,
  amountInSmallestUnit,
  currency,
}) => {
  console.log("💳 Saving payment (backend will read breakdown from temp table)");
  console.log("💳 Payment identifiers:");
  console.log("  orderId (for temp table lookup):", order.id || order.orderId);
  console.log("  razorpayOrderId:", response.razorpay_order_id);
  console.log("  razorpayPaymentId:", response.razorpay_payment_id);
  console.log("  registrationDbId:", registrationDbId);

  const orderIdForSave = order.id || order.orderId || response.razorpay_order_id;
  if (!orderIdForSave) {
    console.error("❌ CRITICAL: orderId is null/undefined!");
    console.error("  order:", JSON.stringify(order, null, 2));
    console.error("  response:", JSON.stringify(response, null, 2));
    throw new Error(
      "Cannot save payment: orderId is missing. Backend needs this to lookup breakdown from temp table."
    );
  }

  if (!registrationDbId) {
    console.error("❌ CRITICAL: registrationDbId is null/undefined!");
    throw new Error("Cannot save payment: registrationDbId is missing.");
  }

  const paymentSaveData = {
    regId: registrationDbId,
    orderId: orderIdForSave,
    razorpayOrderId: response.razorpay_order_id,
    razorpayPaymentId: response.razorpay_payment_id,
    razorpaySignature: response.razorpay_signature,
    status: "SUCCESS",
    amountPaid: amountInSmallestUnit / 100,
    currency: order.currency || currency,
  };

  console.log("📤 Payment save payload:", JSON.stringify(paymentSaveData, null, 2));
  console.log("✅ Payload validation passed - all critical fields present");
  console.log("💰 Amount breakdown:");
  console.log("  amountInSmallestUnit (with fee):", amountInSmallestUnit);
  console.log("  amountPaid (in main currency):", paymentSaveData.amountPaid);
  console.log("  This includes 2.9% convenience fee");

  return paymentSaveData;
};

export const saveSuccessfulPaymentWithBreakdown = async ({
  paymentSaveUrl,
  order,
  response,
  registrationDbId,
  amountInSmallestUnit,
  currency,
  savePaymentWithBreakdown,
}) => {
  const paymentSaveData = buildSuccessfulPaymentSavePayload({
    order,
    response,
    registrationDbId,
    amountInSmallestUnit,
    currency,
  });

  const paymentSaveResult = await savePaymentWithBreakdown({
    paymentSaveUrl,
    payload: paymentSaveData,
  });

  if (paymentSaveResult.ok) {
    return paymentSaveResult;
  }

  const paymentError = paymentSaveResult.errorText;
  console.error("❌ Payment entity save failed!");
  console.error(
    "  HTTP Status:",
    paymentSaveResult.status,
    paymentSaveResult.statusText
  );
  console.error("  Response body:", paymentError);
  console.error("  Payload sent:", JSON.stringify(paymentSaveData, null, 2));
  console.warn("Payment entity save failed:", paymentError);

  return paymentSaveResult;
};
